
/* 
  Deletes a data request file from S3 
  < input = selectedFile >
*/

export async function deleteJSON(S3, fileName) {
  
  // S3 bucket and csv key (prefix and filename)
  const bucket = process.env.REACT_APP_S3_DATAREQUESTS_BUCKET;
  const companyName = localStorage.getItem("company");
  const jsonKey = `${companyName}/public/${fileName}.json`;
 
  try {
    // Delete the JSON file from S3
    await S3.deleteObject({
      Bucket: bucket,
      Key: jsonKey,
    }).promise();

    // The deletion was successful if no error was thrown
    // Console Testing
    console.log("Deleted JSON file successfully");
  } catch (error) {
    console.error("Error deleting file:", error);
  }
}
